import { faCalendar, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { NgForm } from '@angular/forms';
import { Component, ViewEncapsulation, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import { filter, cloneDeep } from 'lodash';
import SelfPayFormDependent from 'src/app/models/selfPayFormDependent';
import { CoreService } from 'src/app/services/core.service';
import SelfPayType from 'src/app/models/selfPayType';
import SelfPay from 'src/app/models/selfPay';
import * as dayjs from 'dayjs';
import { env } from 'src/env/development';
@Component({
  selector: 'self-pay-existing-dependent',
  templateUrl: 'selfPay.existing.dependent.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class SelfPayExistingDependentComponent implements OnChanges, OnInit {
  @Input() selfPayDependent: SelfPayFormDependent;
  @Input() pebbVisionDate: Date;
  @Input() idx: number;
  @Input() requestType: SelfPayType;
  @Input() agency: string;
  @Input() selfPay: SelfPay;
  @Output() submitDependent: EventEmitter<SelfPayFormDependent> = new EventEmitter<SelfPayFormDependent>();
  @Output() closePanel: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('dependentForm') dependentForm: NgForm;
  currentMaxDate: Date;
  noSSN: boolean = false;
  currentDependent: SelfPayFormDependent;
  electMedicalDisabled = false;
  electDentalDisabled = false;
  icons = {
      faCalendar,
      faExclamationCircle
  };
  thirteenYearsDate: Date
  env = env;
  isCobra: boolean = false;
  isPebbLwopVision: boolean = false;
  isPebbRetireeVision: boolean = false;
  isCobraOE: boolean = false;
  isPebbCobraInitial = false;
  isPebbCobraSOE = false;
  isSebbCobra: boolean = false;
  disableFormForNoCoverage = false;
  coverageYear: number;
  otherAgency: string;
  pebbVisionActive = false;

  constructor(private coreService: CoreService){}

  ngOnInit() {
    this.currentMaxDate = new Date();
    this.thirteenYearsDate = dayjs().subtract(13, 'year').toDate();
    //US38584 do not default medicare based on sub 
    // if(this.selfPay){ 
    //   if(this.selfPay.formJson?.subscriber?.medicarePartAInd) {
    //     this.currentDependent.memberMedicare.medicarePartAEnrolledInd = this.selfPay.formJson?.subscriber?.medicarePartAInd;
    //   }
    //   if(this.selfPay.formJson?.subscriber?.medicarePartBInd) {
    //     this.currentDependent.memberMedicare.medicarePartBEnrolledInd = this.selfPay.formJson?.subscriber?.medicarePartBInd;
    //   }
    // }
    this.pebbVisionActive = dayjs(this.selfPay?.coverageEffectiveDate ?? new Date()).isSameOrAfter(this.pebbVisionDate);
    this.currentDependent.surchargeNA = this.selfPay.formJson?.subscriber?.medicarePartBInd && this.selfPay.formJson?.subscriber?.medicarePartAInd;
    this.isPebbLwopVision = this.agency === 'PEBB' && (((this.requestType.selfPayTypeCode === 'ALWOP' || this.requestType.selfPayTypeCode === 'SOEU') && this.pebbVisionActive) || this.requestType.selfPayTypeCode === "OEU");
    this.isPebbRetireeVision = this.agency === 'PEBB' && ((this.requestType.selfPayTypeCode === 'R' && this.pebbVisionActive) || this.requestType.selfPayTypeCode === "OER");
    this.isCobraOE = this.requestType.selfPayTypeCode === "OEC";
    this.isPebbCobraInitial = this.selfPay.isPEBB && this.selfPay.isCobraInitial;
    this.isPebbCobraSOE = this.selfPay.isPEBB && this.selfPay.isCobraSOE;
    this.isSebbCobra = this.selfPay.isSEBB && this.selfPay.isCOBRA;
    this.coverageYear = dayjs(this.selfPay.coverageEffectiveDate ?? new Date()).year();
    this.otherAgency = this.selfPay.isSEBB ? env.pebbCode : env.sebbCode;

    if (this.selfPay.isPEBB && (this.selfPay.isCobraInitial || this.selfPay.isCobraSOE)) {
      if (this.selfPay.formJson.subscriber.medicarePartBInd)
        this.currentDependent.surchargeNA = true;
    }
  }

  ngOnChanges() {
    this.isCobra = env.cobraSelfPayTypeCodes.includes(this.requestType.selfPayTypeCode);
    if (this.selfPayDependent) {
      this.currentDependent = cloneDeep(this.selfPayDependent);
      this.noSSN = this.currentDependent.socialSecurityNumber?.startsWith('99999');
    }
    
    if (this.requestType.selfPayTypeCode === 'R'  || this.requestType.selfPayTypeCode === 'OER') {
      this.electMedicalDisabled = true;
      this.electDentalDisabled = true;

      if (this.requestType.selfPayTypeCode === 'R' && this.selfPay.formJson?.subscriber?.actionsCode === 'deferring' &&
          this.selfPay.formJson?.subscriber?.deferQuestionFour) {
          //initial retiree request is deferring due to medicaid, enable dependent coverage for medical only
          this.electMedicalDisabled = false;
          this.electDentalDisabled = true;
      }
    }

    if(this.selfPay){ 
      // if(this.selfPay.formJson?.subscriber?.medicarePartAInd) {
      //   this.currentDependent.memberMedicare.medicarePartAEnrolledInd = this.selfPay.formJson?.subscriber?.medicarePartAInd;
      // }
      // if(this.selfPay.formJson?.subscriber?.medicarePartBInd) {
      //   this.currentDependent.memberMedicare.medicarePartBEnrolledInd = this.selfPay.formJson?.subscriber?.medicarePartBInd;
      // }
      // if(this.currentDependent.memberMedicare?.medicarePartAEnrolledInd && this.currentDependent.memberMedicare?.medicarePartBEnrolledInd){
      //   // this.currentDependent.surchargeNA = true;  <-- tied to subscriber, not dependent
      //   this.currentDependent.tobaccoUseInd = null;
      // }
 
      if (this.selfPay.formJson.subscriber.medicarePartBInd)
        this.currentDependent.spouseSurchargeTriState = 'N';
    }

    this.isSebbCobra = this.selfPay.isSEBB && this.selfPay.isCOBRA;
    this.isPebbLwopVision = this.agency === 'PEBB' && (((this.requestType.selfPayTypeCode === 'ALWOP' || this.requestType.selfPayTypeCode === 'SOEU') && this.pebbVisionActive) || this.requestType.selfPayTypeCode === "OEU");
  }

  markAllControlsAsTouched(): void {
    this.coreService.markFormControlsAsTouched(this.dependentForm);
  }

  emitSubmitDependent(formContainer) {
    this.markAllControlsAsTouched();
    if (this.dependentForm.valid) {
      this.submitDependent.emit(this.currentDependent);
    } else {
      this.coreService.popMessage('Please complete required fields.', 'error', 4000, this.coreService.getInvalidFields(formContainer));
    }
  }

  cancelChanges() {
    this.currentDependent = cloneDeep(this.selfPayDependent);
    this.closePanel.emit();
  }

  updateTobacco() {
    if (this.currentDependent.surchargeNA) {
      this.currentDependent.tobaccoUseInd = null;
      this.currentDependent.spouseSurchargeTriState = "N";
      this.currentDependent.spouseForm.questionTwoInd = false;
      this.currentDependent.spouseForm.questionThreeInd = false;
      this.currentDependent.spouseForm.questionFourInd = false;
      this.currentDependent.spouseForm.questionFiveInd = false;
      this.currentDependent.spouseForm.questionSixInd = false;
    }
  }

  spousalChange(spouse: SelfPayFormDependent): void {
    if (!(this.selfPay.isPEBB && this.selfPay.isRetireeSOE))
      return;

    if (spouse.spouseAttestQ1 && spouse.spouseAttestQ2 && spouse.spouseAttestQ3 && spouse.spouseAttestQ4 && spouse.spouseAttestQ5 && spouse.spouseAttestQ6)
      this.currentDependent.spouseSurchargeTriState = 'Y';
    else if (spouse.spouseAttestQ1 === false || spouse.spouseAttestQ2 === false || spouse.spouseAttestQ3 === false || spouse.spouseAttestQ4 === false || spouse.spouseAttestQ5 === false || spouse.spouseAttestQ6 === false)
      this.currentDependent.spouseSurchargeTriState = 'N';
  }

  updateCoverageContinue(e, key: string) {
    let bool = (e.target as HTMLInputElement)?.value === 'true';
    if(bool) {
      this.currentDependent[key] = false;
    }else {
      this.currentDependent[key] = true;
    }
  }

  terminateAllCoveragesChange(checked) {
    this.currentDependent.terminateAllCoverageInd = checked;
    this.currentDependent.medicalCoverInd = 
    this.currentDependent.dentalCoverInd =
    this.currentDependent.visionCoverInd = false;
  }

  
  handleMedicalEnrollChange(checked) {
    if(checked) {
       this.currentDependent.terminateAllCoverageInd = false;
      }else if (!checked) {
        
      }
      this.handleCoverageChange(checked);
  }

  updateMedicarePartA(yes: boolean) {
    if(!yes) {
      this.currentDependent.medicarePartADate = null;
      this.currentDependent.medicarePartAInd = false;
    }
    if(yes) {
      this.currentDependent.medicarePartAInd = true;
    }
  }

  updateMedicarePartB(yes: boolean) {
    if(!yes) {
      this.currentDependent.medicarePartBDate = null;
      this.currentDependent.medicarePartBInd = false;
    }
    if(yes) {
      if (!this.isSebbCobra) this.currentDependent.visionCoverInd = false;
      this.currentDependent.medicarePartBInd = true;
    }
  }

  handleCoverageChange(e) {
    if(e && this.currentDependent.medicalCoverInd) {
      this.disableFormForNoCoverage = false;
    }else {
      this.disableFormForNoCoverage = true;
      this.resetFormValues();
    }
  }

  resetFormValues() {
    this.currentDependent.medicarePartAInd =
    this.currentDependent.medicarePartBInd =
    this.currentDependent.spouseSurchargeTriState =
    this.currentDependent.spouseAttestQ1 =
    this.currentDependent.spouseAttestQ2 =
    this.currentDependent.spouseAttestQ3 =
    this.currentDependent.spouseAttestQ4 =
    this.currentDependent.spouseAttestQ5 =
    this.currentDependent.spouseAttestQ6 =
    this.currentDependent.medicareNumber =
    this.currentDependent.medicarePartADate =
    this.currentDependent.medicarePartBDate =
    this.currentDependent.tobaccoUseInd = null
  }

}
